import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import Immutable from 'immutable';
import PropTypes from 'prop-types';
export var DISJUNCTIVE_FACET_TYPE = 'disjunctive';
export var CONJUNCTIVE_FACET_TYPE = 'conjunctive';

var FacetType = /*#__PURE__*/function (_Immutable$Record) {
  _inherits(FacetType, _Immutable$Record);

  var _super = _createSuper(FacetType);

  function FacetType() {
    _classCallCheck(this, FacetType);

    return _super.apply(this, arguments);
  }

  _createClass(FacetType, null, [{
    key: "disjunctive",
    value: function disjunctive(algoliaFacetKey) {
      return new FacetType({
        algoliaFacetKey: algoliaFacetKey,
        queryType: DISJUNCTIVE_FACET_TYPE
      });
    }
  }, {
    key: "conjunctive",
    value: function conjunctive(algoliaFacetKey) {
      return new FacetType({
        algoliaFacetKey: algoliaFacetKey,
        queryType: CONJUNCTIVE_FACET_TYPE
      });
    }
  }]);

  return FacetType;
}(Immutable.Record({
  algoliaFacetKey: undefined,
  queryType: undefined
}));

export { FacetType as default };
export var FacetTypePropType = PropTypes.instanceOf(FacetType);